import { useMemo } from 'react';

import { useAuth } from '@modules/auth/hooks';
import { checkCorrectUserGroupName, getOrganizationNameFromUserGroup } from '@modules/core/utils';
import { useAuthStore } from '@/modules/auth/store';

const useOrganizationName = (): string | undefined => {
  const { idToken } = useAuth();
  const { user } = useAuthStore();

  const organizationName = useMemo(() => {
    if (idToken === undefined) {
      return;
    }

    if (user?.profile.organization !== undefined) {
      return user?.profile.organization;
    }

    const groups: string[] = idToken?.claims.groups as string[];

    const groupWithOrgAndRole = groups?.find(checkCorrectUserGroupName);

    if (groupWithOrgAndRole === undefined) {
      throw new Error('User without correct group name');
    }

    return groups !== undefined ? getOrganizationNameFromUserGroup(groupWithOrgAndRole) : '';
  }, [idToken]);
  return organizationName;
};

export default useOrganizationName;
